import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'talent-list',
  name: '演员列表',
  icon: '演',
  group: '业务组件',
  description: '读取演员数据并渲染客户端演员卡片',
  defaultProps: {
    title: '推荐演员',
    limit: 12
}
}
